import { styled } from "@mui/material/styles";
import { ListItemIcon, ListItemButton } from "@mui/material";

export const StyledNavItem = styled((props) => (
  <ListItemButton disableGutters {...props} />
))(({ theme }) => ({
  ...theme.typography.body2,
  height: 44,
  position: "relative",
  textTransform: "capitalize",
  color: theme.palette.text.secondary,
  borderRadius: theme.shape.borderRadius,
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  "&::before": {
    content: '""',
    position: "absolute",
    left: -8,
    top: 8,
    bottom: 8,
    width: 3,
    borderRadius: 2,
    backgroundColor: "transparent",
    transition: theme.transitions.create("background-color", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  "&.active": {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.action.selected,
    fontWeight: theme.typography.fontWeightBold,
    "&::before": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const StyledNavItemIcon = styled(ListItemIcon)({
  width: 22,
  height: 22,
  color: "inherit",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
